var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00887 2.04748L9.03554 4.10081C9.17554 4.38664 9.54887 4.66081 9.86387 4.71331L11.7247 5.02248C12.9147 5.22081 13.1947 6.08414 12.3372 6.93581L10.8905 8.38248C10.6455 8.62748 10.5114 9.09998 10.5872 9.43831L11.0014 11.2291C11.328 12.6466 10.5755 13.195 9.32137 12.4541L7.5772 11.4216C7.2622 11.235 6.74304 11.235 6.4222 11.4216L4.67804 12.4541C3.4297 13.195 2.67137 12.6408 2.99804 11.2291L3.4122 9.43831C3.48804 9.09998 3.35387 8.62748 3.10887 8.38248L1.6622 6.93581C0.810536 6.08414 1.0847 5.22081 2.2747 5.02248L4.13554 4.71331C4.4447 4.66081 4.81804 4.38664 4.95804 4.10081L5.9847 2.04748C6.5447 0.933311 7.4547 0.933311 8.00887 2.04748Z",
    stroke: "#F1CF24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.135c2d376d9f5af4efc8e92f9c375be2.svg";
export { ForwardRef as ReactComponent };